import React from "react";
import { LogControl } from "~/components/shared/Log";
import Icon from "~/components/shared/Icon";

type Props = {
  theme: "default" | "solarized";
  onToggle: () => void;
};

export default function ThemeToggleControl({ theme, onToggle }: Props) {
  return (
    <LogControl onClick={onToggle}>
      <Icon
        icon={theme === "default" ? "heroicons/16/solid/sun" : "heroicons/16/solid/moon"}
        className="h-4 w-4"
      />
      Theme
    </LogControl>
  );
}
